/**
 * SIMPS Drink Lab — cartService.js
 * Does NOT alter/replace/refactor the theme's cart, drawer, discount,
 * checkout, Recharge, or bundle behaviour.
 *
 * Uses Shopify's native /cart/add.js Ajax endpoint (present on every
 * Shopify storefront regardless of theme) via fetch, rather than a real
 * <form> submission. A real form submission navigates the page — fine for
 * a single item, but fatal for the Lab Pack's 3-item add, since the first
 * submission's navigation kills the page before the 2nd/3rd items are ever
 * requested. Fetch avoids navigation entirely and lets multiple items be
 * added in a single request via Shopify's own "items" array support.
 * This does not touch, call, or depend on assets/cart.js in any way.
 *
 * _Result_Type line-item property (exact | close_match | dash_favorites)
 * is the only analytics surface this build has, since the app deliberately
 * avoids dispatching custom events into the theme. It lands on the order
 * so gaps in the recipe library (lots of close_match/dash_favorites) are
 * visible in order data.
 */
window.DrinkLab = window.DrinkLab || {};

(function () {
  function addUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add.js'; }
  function numericVariantId(gid) { if (!gid) return null; const parts = String(gid).split('/'); return parts[parts.length - 1]; }

  async function addItemsToCart(items) {
    const payload = {
      items: items.map((item) => ({
        id: Number(numericVariantId(item.variantId)),
        quantity: item.quantity || 1,
        properties: item.properties || {}
      }))
    };
    const res = await fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) {
      let message = 'Could not add to cart.';
      try { const errBody = await res.json(); if (errBody && errBody.description) message = errBody.description; } catch (e) { /* ignore */ }
      throw new Error(message);
    }
    return res.json();
  }

  function addHeroToCart(heroRef, recipeId, recipeName, resultType) {
    if (!heroRef || !heroRef.variantId) return Promise.reject(new Error('No variant available for this product.'));
    const properties = { _Drink_Lab: 'true', _Experiment: recipeId, _Recommendation: recipeName };
    if (resultType) properties._Result_Type = resultType;
    return addItemsToCart([{ variantId: heroRef.variantId, quantity: 1, properties }]);
  }

  function addUpgradeToCart(upgradeRef, recipeId, resultType) {
    if (!upgradeRef || !upgradeRef.variantId) return Promise.reject(new Error('No variant available for this product.'));
    const properties = { _Drink_Lab: 'true', _Experiment: recipeId, _Upgrade: 'true' };
    if (resultType) properties._Result_Type = resultType;
    return addItemsToCart([{ variantId: upgradeRef.variantId, quantity: 1, properties }]);
  }

  function addLabPackToCart(productRefs, labPackId, resultType) {
    const valid = (productRefs || []).filter((ref) => ref && ref.variantId);
    if (valid.length === 0) return Promise.reject(new Error('No variants available for this lab pack.'));
    return addItemsToCart(valid.map((ref) => {
      const properties = { _Drink_Lab: 'true', _Lab_Pack: labPackId };
      if (resultType) properties._Result_Type = resultType;
      return { variantId: ref.variantId, quantity: 1, properties };
    }));
  }

  window.DrinkLab.CartService = { addHeroToCart, addUpgradeToCart, addLabPackToCart, addItemsToCart };
})();
